import React from 'react';
import {connect} from 'react-redux';
import Button from "@material-ui/core/Button";
import {clearHiddenMarkers} from "../../../store/markerSlice";

const ClearHiddenMarkers = (props) => {
	if( !props.hidden || !Object.keys(props.hidden).length )
		return null;

	return (
		<Button variant='contained' color='secondary' onClick={props.clearHiddenMarkers}>Clear Hidden Markers</Button>
	);
};

const mapStateToProps = (state) => {
	return {
		hidden: state.marker.hidden
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		// NAME: (value) => dispatch(FN(value)),
		clearHiddenMarkers: () => dispatch(clearHiddenMarkers())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ClearHiddenMarkers);